/* HEYOO 24h 客服聊天组件 - widget.js
 * 嵌入 Shopify 网站右下角，连接桥接服务（Eva 客服 AI）
 * 部署时修改 BRIDGE_URL 为实际桥接服务地址
 */
(function () {
  // ====== 配置 ======
  var BRIDGE_URL = 'https://occurring-currently-garbage-david.trycloudflare.com'; // 部署时替换为实际公网地址
  var TELEGRAM_BOT = 'mskcdbot'; // Eva 的 Telegram bot（HEYOO 客服真人通道）
  var TELEGRAM_LINK = 'https://t.me/' + TELEGRAM_BOT;
  var STORE_NAME = 'HEYOO';
  var WELCOME_PT = 'Olá! 👋 Sou a Eva, atendente da HEYOO. Como posso ajudar?';
  var WELCOME_EN = "Hi! 👋 I'm Eva from HEYOO. How can I help you?";
  var WELCOME_ZH = '你好！👋 我是 HEYOO 的客服 Eva，请问有什么可以帮您？';

  // 获取语言（葡语优先，其次英文，再中文）
  function detectLang() {
    var lang = (navigator.language || 'pt').toLowerCase();
    if (lang.indexOf('pt') === 0) return 'pt';
    if (lang.indexOf('zh') === 0) return 'zh';
    return 'en';
  }

  var lang = detectLang();
  var WELCOME = lang === 'pt' ? WELCOME_PT : lang === 'zh' ? WELCOME_ZH : WELCOME_EN;

  // ====== 样式 ======
  var css = [
    '#heyoo-chat-launcher{position:fixed;bottom:124px;right:24px;z-index:999999;width:60px;height:60px;border-radius:50%;background:#FF6B35;color:#fff;border:none;cursor:pointer;box-shadow:0 4px 16px rgba(0,0,0,.25);display:flex;align-items:center;justify-content:center;font-size:28px;transition:transform .2s}',
    '#heyoo-chat-launcher:hover{transform:scale(1.08)}',
    '#heyoo-chat-window{position:fixed;bottom:196px;right:24px;z-index:999999;width:360px;max-width:calc(100vw - 32px);height:520px;max-height:calc(100vh - 130px);background:#fff;border-radius:16px;box-shadow:0 8px 32px rgba(0,0,0,.25);display:none;flex-direction:column;overflow:hidden;font-family:-apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,sans-serif}',
    '#heyoo-chat-window.open{display:flex}',
    '#heyoo-chat-head{background:#FF6B35;color:#fff;padding:14px 16px;display:flex;align-items:center;gap:10px}',
    '#heyoo-chat-head .avatar{width:36px;height:36px;border-radius:50%;background:#fff;color:#FF6B35;display:flex;align-items:center;justify-content:center;font-weight:700;font-size:16px}',
    '#heyoo-chat-head .title{flex:1}',
    '#heyoo-chat-head .title b{display:block;font-size:14px}',
    '#heyoo-chat-head .title span{font-size:11px;opacity:.9}',
    '#heyoo-chat-head .online{width:8px;height:8px;border-radius:50%;background:#7CFC00;display:inline-block;margin-right:4px}',
    '#heyoo-chat-close{background:none;border:none;color:#fff;font-size:20px;cursor:pointer;padding:0 4px}',
    '#heyoo-chat-tg-float{position:fixed;bottom:284px;right:24px;z-index:999999;width:56px;height:56px;border-radius:50%;background:#229ED9;color:#fff;border:none;cursor:pointer;box-shadow:0 4px 16px rgba(0,0,0,.25);display:flex;align-items:center;justify-content:center;transition:transform .2s}',
    '#heyoo-chat-tg-float:hover{transform:scale(1.1)}',
    '#heyoo-chat-tg-float svg{width:30px;height:30px;fill:#fff}',
    '#heyoo-chat-tg-float .tg-badge{position:absolute;top:-6px;right:-6px;background:#FF6B35;color:#fff;font-size:10px;font-weight:700;padding:2px 6px;border-radius:10px;box-shadow:0 2px 6px rgba(0,0,0,.25)}',
    '#heyoo-chat-body{flex:1;overflow-y:auto;padding:14px;background:#f7f8fa;display:flex;flex-direction:column;gap:10px}',
    '.heyoo-msg{max-width:82%;padding:9px 12px;border-radius:12px;font-size:13px;line-height:1.5;word-wrap:break-word;white-space:pre-wrap}',
    '.heyoo-msg.user{align-self:flex-end;background:#FF6B35;color:#fff;border-bottom-right-radius:4px}',
    '.heyoo-msg.bot{align-self:flex-start;background:#fff;color:#222;border-bottom-left-radius:4px;box-shadow:0 1px 3px rgba(0,0,0,.08)}',
    '.heyoo-msg.sys{align-self:center;background:#eee;color:#666;font-size:11px;padding:4px 10px;border-radius:20px}',
    '#heyoo-chat-typing{align-self:flex-start;background:#fff;color:#999;font-size:12px;padding:8px 12px;border-radius:12px;border-bottom-left-radius:4px;display:none}',
    '#heyoo-chat-input{display:flex;gap:8px;padding:10px;border-top:1px solid #eee;background:#fff}',
    '#heyoo-chat-input textarea{flex:1;border:1px solid #ddd;border-radius:20px;padding:9px 14px;font-size:13px;resize:none;outline:none;max-height:80px;font-family:inherit}',
    '#heyoo-chat-input textarea:focus{border-color:#FF6B35}',
    '#heyoo-chat-send{background:#FF6B35;color:#fff;border:none;border-radius:20px;padding:0 18px;font-size:14px;cursor:pointer;font-weight:600}',
    '#heyoo-chat-send:disabled{opacity:.5;cursor:not-allowed}',
    '#heyoo-chat-handoff{display:block;margin:8px auto;background:none;border:1px solid #FF6B35;color:#FF6B35;border-radius:20px;padding:6px 16px;font-size:12px;cursor:pointer}'
  ].join('');
  var style = document.createElement('style');
  style.textContent = css;
  document.head.appendChild(style);

  // ====== DOM ======
  var launcher = document.createElement('button');
  launcher.id = 'heyoo-chat-launcher';
  launcher.innerHTML = '💬';
  launcher.title = STORE_NAME + (lang === 'pt' ? ' Atendimento' : lang === 'zh' ? ' 客服' : ' Support');
  document.body.appendChild(launcher);

  var win = document.createElement('div');
  win.id = 'heyoo-chat-window';
  win.innerHTML =
    '<div id="heyoo-chat-head">' +
    '<div class="avatar">E</div>' +
    '<div class="title"><b>' + STORE_NAME + (lang === 'pt' ? ' Atendimento' : lang === 'zh' ? ' 客服' : ' Support') + '</b><span><i class="online"></i>' + (lang === 'pt' ? 'Online 24h · Eva' : lang === 'zh' ? '24h 在线 · Eva' : '24h online · Eva') + '</span></div>' +
    '<button id="heyoo-chat-close">✕</button>' +
    '</div>' +
    '<div id="heyoo-chat-body"></div>' +
    '<div id="heyoo-chat-input">' +
    '<textarea id="heyoo-chat-text" rows="1" placeholder="' + (lang === 'pt' ? 'Digite sua mensagem...' : lang === 'zh' ? '请输入消息...' : 'Type your message...') + '"></textarea>' +
    '<button id="heyoo-chat-send">' + (lang === 'pt' ? 'Enviar' : lang === 'zh' ? '发送' : 'Send') + '</button>' +
    '</div>' +
    '<button id="heyoo-chat-handoff" style="display:none">' + (lang === 'pt' ? 'Falar com atendente humano' : lang === 'zh' ? '转接人工客服' : 'Talk to a human agent') + '</button>';
  document.body.appendChild(win);

  // ====== 独立 Telegram 浮动按钮（2026-08-25 从聊天窗头部拆出，上移 200px）======
  var tgFloat = document.createElement('button');
  tgFloat.id = 'heyoo-chat-tg-float';
  tgFloat.title = 'Telegram';
  tgFloat.innerHTML =
    '<svg viewBox="0 0 24 24"><path d="M9.78 18.65l.28-4.23 7.68-6.92c.34-.31-.07-.46-.52-.19L7.74 13.3 3.64 12c-.88-.25-.89-.86.2-1.3l15.97-6.16c.73-.33 1.43.18 1.15 1.3l-2.72 12.81c-.19.91-.74 1.13-1.5.71L12.6 16.3l-1.99 1.93c-.23.23-.42.42-.83.42z"/></svg>' +
    '<span class="tg-badge">TG</span>';
  document.body.appendChild(tgFloat);

  var body = win.querySelector('#heyoo-chat-body');
  var textarea = win.querySelector('#heyoo-chat-text');
  var sendBtn = win.querySelector('#heyoo-chat-send');
  var tgBtn = tgFloat;
  var handoffBtn = win.querySelector('#heyoo-chat-handoff');
  var typing = null;

  // sessionId（localStorage 持久化）
  var sidKey = 'heyoo_chat_sid';
  var sessionId = localStorage.getItem(sidKey) || ('web_' + Date.now().toString(36) + '_' + Math.random().toString(36).slice(2, 8));
  localStorage.setItem(sidKey, sessionId);

  // 显示消息
  function addMsg(role, text) {
    var div = document.createElement('div');
    div.className = 'heyoo-msg ' + role;
    div.textContent = text;
    body.appendChild(div);
    body.scrollTop = body.scrollHeight;
    return div;
  }

  function showTyping() {
    hideTyping();
    typing = document.createElement('div');
    typing.id = 'heyoo-chat-typing';
    typing.textContent = lang === 'pt' ? 'Eva está digitando…' : lang === 'zh' ? 'Eva 正在输入…' : 'Eva is typing…';
    body.appendChild(typing);
    body.scrollTop = body.scrollHeight;
  }
  function hideTyping() {
    if (typing) { typing.remove(); typing = null; }
  }

  // 发送消息
  function send() {
    var msg = textarea.value.trim();
    if (!msg) return;
    addMsg('user', msg);
    textarea.value = '';
    textarea.style.height = 'auto';
    sendBtn.disabled = true;
    showTyping();

    fetch(BRIDGE_URL + '/api/chat', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ sessionId: sessionId, message: msg, lang: lang })
    })
      .then(function (r) { return r.json(); })
      .then(function (d) {
        hideTyping();
        if (d.ok) {
          addMsg('bot', d.reply);
          if (d.handoff) { handoffBtn.style.display = 'block'; }
        } else {
          addMsg('sys', d.error || (lang === 'pt' ? 'Erro no serviço, tente novamente.' : lang === 'zh' ? '服务异常，请稍后再试。' : 'Service error, please try again later.'));
        }
        sendBtn.disabled = false;
      })
      .catch(function () {
        hideTyping();
        addMsg('sys', lang === 'pt' ? 'Erro de rede, tente novamente.' : lang === 'zh' ? '网络异常，请稍后再试。' : 'Network error, please try again later.');
        sendBtn.disabled = false;
      });
  }

  // 事件
  launcher.addEventListener('click', function () {
    var open = win.classList.toggle('open');
    if (open && !body.children.length) addMsg('bot', WELCOME);
  });
  win.querySelector('#heyoo-chat-close').addEventListener('click', function () {
    win.classList.remove('open');
  });
  sendBtn.addEventListener('click', send);
  tgBtn.addEventListener('click', function () {
    window.open(TELEGRAM_LINK, '_blank');
  });
  textarea.addEventListener('keydown', function (e) {
    if (e.key === 'Enter' && !e.shiftKey) { e.preventDefault(); send(); }
  });
  textarea.addEventListener('input', function () {
    textarea.style.height = 'auto';
    textarea.style.height = Math.min(textarea.scrollHeight, 80) + 'px';
  });
  handoffBtn.addEventListener('click', function () {
    addMsg('sys', lang === 'pt' ? 'Transferindo para atendente humano...' : lang === 'zh' ? '正在转接人工客服...' : 'Transferring to human agent...');
    fetch(BRIDGE_URL + '/api/handoff', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ sessionId: sessionId })
    }).catch(function () {});
    handoffBtn.style.display = 'none';
  });
})();
